<div class="error-view-container">
  <h1 class="error-header">Error Occurred</h1>
  <h4 class="error-subheader">Something went wrong. Please try again later.</h4>
</div>
